import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-322c0d0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row image-selector" }
const _hoisted_2 = { class: "col-10" }
const _hoisted_3 = ["required", "id"]
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = ["src", "width"]
const _hoisted_6 = { class: "col px-0" }

import { computed, ref, onMounted } from 'vue'
import { message } from '@/plugins/message'


export default /*#__PURE__*/_defineComponent({
  __name: 'InputImage',
  props: {
  modelValue: { type: String, default: '' },
  required: { type: Boolean, default: false },
  width: { type: Number, default: 300 },
  id: { type: String, default: 'image' }
},
  emits: ["update:modelValue", "change", "reset"],
  setup(__props, { emit }: { emit: ({
  (event: 'update:modelValue', src: string): void,
  (event: 'change', file: File|null): void
  (event: 'reset'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props



// eslint-disable-next-line func-call-spacing


const file = ref<File|null>(null)
const fileRef = ref<HTMLInputElement>()
const error = ref('')
const src = computed({
  get: () => props.modelValue,
  set: (src) => emit('update:modelValue', src)
})
const image:any = ref()
onMounted(() => {
  image.value= document.getElementById("image")
})

/**
 * ファイル形式が不正な場合に送出するエラー
 */
class InvalidFileTypeError extends Error {
  constructor(...params: any) {
    super(...params)
    this.name = 'InvalidFileTypeError'
  }
}
/**
 * ファイルのフォーマット識別子による判定
 */
const getFileType = (buffer: ArrayBuffer) => {
  const bytes = new Uint8Array(buffer).subarray(0, 4)
  const header = Array.from(bytes).map(byte => byte.toString(16)).join('')
  if (/^89504e47/.test(header)) {
    return 'image/png'
  } else if (/^47494638/.test(header)) {
    return 'image/gif'
  } else if (/^424d/.test(header)) {
    return 'image/bmp'
  } else if (/^ffd8ff/.test(header)) {
    return 'image/jpeg'
  } else if (/^3c737667/.test(header)) {
    return 'image/svg+xml'
  }
  throw new InvalidFileTypeError("Unknown file type.")
}

const preview = async(e: Event): Promise<void> => {
  const reader = new FileReader()
  reader.onload = (e: any) => {
    src.value = e.target.result
  }
  error.value = ''
  try {
    if (e.target instanceof HTMLInputElement
      && e.target.files && e.target.files.length > 0) {
      file.value = e.target.files[0]
      emit('change', file.value)
      getFileType(await e.target.files[0].arrayBuffer())
      reader.readAsDataURL(file.value)
    }
  } catch (err: any) {
    if (err.name === 'InvalidFileTypeError') {
      error.value = message('validation.isNotImage')
      src.value = ''
    }
  }
  image.value.setCustomValidity(error.value)
}
const reset = (): void => {
  if (fileRef.value) {
    fileRef.value.value = ''
    src.value = ''
  }
  error.value = ''
  image.value.setCustomValidity('')
  file.value = null
  emit('change', file.value)
  emit('reset')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          class: "form-control",
          type: "file",
          ref_key: "fileRef",
          ref: fileRef,
          accept: "image/*",
          onChange: preview,
          required: __props.required,
          id: __props.id
        }, null, 40, _hoisted_3),
        _createElementVNode("div", _hoisted_4, _toDisplayString(error.value), 1),
        _withDirectives(_createElementVNode("img", {
          src: _unref(src),
          class: "mt-2",
          width: __props.width
        }, null, 8, _hoisted_5), [
          [_vShow, _unref(src)]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("button", {
          class: "btn btn-secondary",
          type: "button",
          onClick: reset
        }, " クリア ", 512), [
          [_vShow, file.value != null]
        ])
      ])
    ])
  ]))
}
}

})